/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Confirm_TitleInputs */

const en_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription?`)
};

const fr_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler l'abonnement ?`)
};

const de_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement kündigen?`)
};

const it_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annullare l'abbonamento?`)
};

const ru_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить подписку?`)
};

const es_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cancelar suscripción?`)
};

const zh_cn2_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅？`)
};

const ja_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションをキャンセルしますか?`)
};

const hi_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता रद्द करना चाहते हैं?`)
};

const pt_pt2_cancel_confirm_title = /** @type {(inputs: Cancel_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar assinatura?`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription?" |
*
* @param {Cancel_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_confirm_title = /** @type {((inputs?: Cancel_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_confirm_title(inputs)
	if (locale === "de") return de_cancel_confirm_title(inputs)
	if (locale === "it") return it_cancel_confirm_title(inputs)
	if (locale === "ru") return ru_cancel_confirm_title(inputs)
	if (locale === "es") return es_cancel_confirm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_confirm_title(inputs)
	if (locale === "ja") return ja_cancel_confirm_title(inputs)
	if (locale === "hi") return hi_cancel_confirm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_confirm_title(inputs)
	return en_cancel_confirm_title(inputs)
});